<template>
  <div class="supershooter">
    <div class="mainWidth">
      <div class="main_box">
        <mu-row gutter class="main_tags">
          <mu-row gutter  class="tags_img_box">
            <mu-col width="100" tablet="30" desktop="30">
              <div class="tags_img">
                <img :src="$t('service.supershooter.foundImg')">
              </div>
            </mu-col>
            <mu-col class="tags_detail_box" width="100" tablet="70" desktop="70">
              <div class="tags_title_box">
                <div class="tags_intro_title">{{$t('service.supershooter.title')}}</div>
                <div class="tags_intro_subtitile">{{$t('service.supershooter.subtitle')}}</div>
              </div>

              <div class="tags_detail">
                <span>{{$t('service.supershooter.intro[0]')}}</span>
              </div>
            </mu-col>
          </mu-row>

        </mu-row>
      </div>
    </div>
    <div class="mainWidth">
      <div class="merits_box">
        <mu-row gutter class="merit_list">
          <mu-col width="100" tablet="50" desktop="25" class=""  v-for="item in $t('service.supershooter.tags')" :key="item.title">
            <div class="icon"><img :src="item.icon" alt=""></div>
            <div class="title">{{item.title}}</div>
          </mu-col>
        </mu-row>
        <mu-row gutter class="main_merits">
          <mu-col class="" width="100" tablet="33" desktop="33"  v-for="item in $t('service.supershooter.merits')" :key="item">
            <div class="merits">
              <span class="merits_icon"></span><span class="merits_item">{{item}}</span>
            </div>
          </mu-col>

        </mu-row>
        <div class="main_imgs">
          <div  class="imgs_box" v-for="item in $t('service.supershooter.introImgs')">
            <img :src="item.imgs" alt="">
            <div class="description">
              {{item.description}}
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  export default {
    name: 'erange',
    data () {
      return {
        activeTab:'0',
      }
    },
    created(){

    },
    methods:{
      changeTab(idx){  //tab切换
        this.activeTab=idx;
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .supershooter{
    overflow:hidden;
    background-color:#E6E6E6;
    padding-bottom:60px;
    .main_box{
      background:#fff;
      overflow:hidden;
      margin-top:17px;


      .main_tags{
        .tags_img_box{
          width:100%;
          height:auto;
          background: #FFFFFF;

          .tags_img{
            width:300px;
            height:300px;
            position:relative;

            >img{
              height:inherit;
              widht:inherit;
              position:absolute;
            }
          }
          .tags_detail_box{
            .tags_title_box{
              margin-right:34px;
              height:134px;
              border-bottom:3px solid #6FA0FF;
              display:inline-block;
              .tags_intro_title{
                height:40px;
                line-height:40px;
                margin-top:40px;
                font-family: PingFangSC-Medium;
                font-size: 24px;
                color: #3B3B3B;
                letter-spacing: 0;
                display:inline-block;
                text-align:left;
                vertical-align:middle;
                width:auto;

              }
              .tags_intro_subtitile{
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #9196AC;
                letter-spacing: 0;
                width:auto;
              }
            }
            .tags_detail{
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color:#9196AC;
              letter-spacing:0;
              line-height: 27px;
              margin-right:34px;
              padding:40px 180px 0px 0px;
              border-top:3px solid #E8E8E8;
              margin-top:-3px;
            }
            .tags{
              span{
                font-family: PingFangSC-Semibold;
                font-size: 14px;
                color: #FF6363;
                letter-spacing: 0;
                line-height: 22px;
                padding:0px 8px;
                font-weight:600;
              }
              .tags_icon{
                width:16px;
                height:13px;
                display:inline-block;
                margin-right:8px;
                img{
                  width:inherit;
                  height:inherit;
                }
              }
            }


          }

        }

      }

    }
    .merits_box{
      overflow:hidden;
      background:#fff;
      margin-top:17px;
      padding:67px;
      .merit_list{
        width:100%;
        height:auto;
        overflow:hidden;
        .icon{
          width:82px;
          height:82px;
          margin:0 auto;
          >img{
            width:inherit;
            height:inherit;
          }
        }
        .title{
          text-align:center;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #333333;
          letter-spacing: 0;
          line-height:60px;
          border-bottom:1px solid #E8E8E8;
        }
      }
      .main_merits{
        margin:60px 0px 0px;
        .merits{
          .merits_icon{
            display: inline-block;
            width:13px;
            height:13px;
            background: url("../../../static/star-1.png") no-repeat center center;
            background-size: 100% 100%;
            margin-right:8px;
            vertical-align: middle;
          }
          .merits_item{
            display:inline-block;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color:#3B3B3B;
            letter-spacing: 0;
            line-height: 16px;
            font-weight: 600;
            vertical-align: middle;
          }
        }
      }
      .main_imgs{
        margin:0px 102px;

        .imgs_box{
          width:80%;
          margin:0 auto;
          >img{
            width:100%;
            height:auto;
            margin:60px 0px;
            text-align:center;
            display:inline-block;
          }
          .description{
            font-family: PingFangSC-Medium;
            font-size: 24px;
            line-height:30px;
            color:#3B3B3B;
            letter-spacing: 0;
            width:75%;
            margin:0 auto;
            text-align:center;
          }
        }
      }
    }
  }

</style>




// WEBPACK FOOTER //
// src/page/childrens/supershooter.vue